import accountBg from 'assets/images/bg/account.jpg';
import { colors } from 'constants/theme';
import { css } from '@emotion/css';

const helpPageStyles = {
    wrap: css`
        background: url(${accountBg}) no-repeat center;
        background-size: cover;
        min-height: 100vh;
        padding: 32px 0;
    `,
    inner: css`
        display: flex;
        border-radius: 16px;
        overflow: hidden;
        height: 100%;
        max-width: 1200px;
        margin: 0 auto;
        background: #fff;
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
    `,
    left: css`
        background: ${colors.primary};
        padding: 24px 0;
        flex: 0 0 240px;
        display: flex;
        flex-direction: column;
        gap: 8px;
    `,
    viewOption: css`
        padding: 12px 10px;
        margin: 0 16px;
        border-radius: 8px;
        cursor: pointer;
        font-weight: 500;
        color: #fff;
        transition: all 0.3s ease;
        background: transparent;

        &:hover {
            background: rgba(255, 255, 255, 0.15);
        }

        &.active {
            background: #fff;
            color: ${colors.primary};
            font-weight: 600;
            box-shadow: 0 2px 6px rgba(0, 0, 0, 0.06);
        }
    `,
    right: css`
        flex: 1;
        padding: 20px;
        overflow-y: auto;
        color: #333;
        line-height: 1.65;
        font-size: 16px;
        font-family: 'Segoe UI', 'Helvetica Neue', sans-serif;

        p {
            margin-bottom: 24px;
        }

        ul, ol {
            padding-left: 20px;
            margin: 12px 0;
        }

        strong {
            font-weight: bold;
        }
    `,
    textTitle: css`
        color: ${colors.primary};
        font-weight: bold;
        font-size: 18px;
        display: block;
    `,
    textLink: css`
        color: ${colors.primary};
        text-decoration: underline;

        &:hover {
            opacity: 0.8;
        }
    `,
};

export default helpPageStyles;
